// Central unit helpers. Internal canonical units: distance in km (backend),
// linear dimensions in METRES. All customer/retailer-facing DISTANCE is shown
// in MILES; linear DIMENSIONS are shown in the user's chosen unit (cm | in).
// Area is always square metres (m²) — never relabelled cm/in.

export const KM_PER_MILE = 1.60934;
export const CM_PER_IN = 2.54; // exact

// ---------- Distance (km internal -> miles display) ----------
export const kmToMiles = (km) => (km == null ? null : km / KM_PER_MILE);
export const milesToKm = (mi) => (mi == null ? null : mi * KM_PER_MILE);

// Short chip label, e.g. "~3.2 mi"
export function milesShort(km) {
  if (km == null) return null;
  const mi = km / KM_PER_MILE;
  const r = Math.round(mi * 10) / 10;
  return `${Number.isInteger(r) ? r : r.toFixed(1)} mi`;
}

// ---------- Linear dimensions (metres internal <-> cm/in display) ----------
export const DIM_UNITS = ["cm", "in"];
export const unitLabel = (unit) => (unit === "in" ? "in" : "cm");

// metres -> display value in the chosen unit (rounded to 1dp, trimmed)
export function mToUnit(m, unit) {
  if (m == null || m === "" || isNaN(Number(m))) return "";
  const v = unit === "in" ? (Number(m) * 100) / CM_PER_IN : Number(m) * 100;
  const r = Math.round(v * 10) / 10;
  return Number.isInteger(r) ? String(r) : String(r);
}

// display value in the chosen unit -> metres (full precision, no rounding)
export function unitToM(val, unit) {
  if (val == null || val === "" || isNaN(Number(val))) return null;
  const n = Number(val);
  return unit === "in" ? (n * CM_PER_IN) / 100 : n / 100;
}

// Convert a display value from one unit to another (for the live unit switch).
export function convertDisplay(val, fromUnit, toUnit) {
  if (val === "" || val == null || isNaN(Number(val))) return val;
  if (fromUnit === toUnit) return val;
  const m = unitToM(val, fromUnit);
  return mToUnit(m, toUnit);
}

// "2.4m × 3.6m" style label but in the chosen unit, e.g. "240 × 360 cm".
export function dimPairLabel(widthM, lengthM, unit) {
  const w = mToUnit(widthM, unit);
  const l = mToUnit(lengthM, unit);
  if (w === "" || l === "") return "";
  return `${w} × ${l} ${unitLabel(unit)}`;
}
